// Read more here: https://medium.com/@andsens/radial-progress-indicator-using-css-a917b80c43f9

define('components/RadialProgress/RadialProgressComponent',[
	'jquery',
	'core/can',
	'text!components/RadialProgress/RadialProgressView.stache'
], function($, can, template) {
	
	var incr = 180 / 100;
	
	function transform(el, deg) {
		var rotate = 'rotate('+deg+'deg)';
		el.css({
			'-webkit-transform': rotate,
			'-ms-transform': rotate,
			'transform': rotate
		});
	}
	
	return can.Component.extend({
		
		tag: 'radial-progress',
		
		template: template,
		
		scope: function(attrs) {
			return {
				percent: parseInt(attrs.percent),
				text: '@'
			}
		},
		
		events: {
			'inserted': function() {
				var deg = this.scope.attr('percent') * incr,
					circle = this.element.find('.circle'),
					set1 = circle.find('.mask.full, .fill'),
					set2 = circle.find('.fill.fix');
				window.setTimeout(function() {
					transform(set1, deg);
					transform(set2, deg*2);
				}, 0);
			}
		}
	});	

});
